import { Checkbox, Popconfirm } from "antd";
import SwitchBox from "../../components/SwitchBox/SwitchBox";
import {
  BankProvider,
  Category,
  DealerBonus,
  Motor,
  Scheme,
  Type,
  Usage,
  accordionData,
} from "./UserData";

import AccordionBlock from "./AccordionBlock";
import { useEffect, useState } from "react";
import SwitchButton from "../../components/SwitchButton/SwitchButton";
import { Button } from "@mui/material";
import CommonPopup from "../../components/popup/CommonPopup";
import { ReactComponent as Arrow } from "../../images/arrow.svg";
import BonusCard from "./BonusCard";
import { LtHtContent } from "../../common/Constants";

const defaultState = {
  open: false,
  product: "",
  interest: "",
  agent_bonus: [],
  interest_bonus: "",
};

const ManageBonus = (props) => {
  const {
    pagePermissions,
    dealerBonusProducts,
    dealerBonusList,
    selectedAccordian,
    setSelectedAccordian,
    HandleDealerSelection,
    selectedDealerBonus,
    UpdateBonus,
    settingsData,
    settingsIndex,
    settingsHandle,
    applyFilters,
    setApplyFilters,
    setMultiSelect,
    multiSelect,
    setSelectedDealerBonus,
  } = props;
  console.log("settingsIndex", settingsIndex, settingsData?.categories);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isHighTemp, setIsHighTemp] = useState(false);
  const [isOpenBonus, setisOpenBonus] = useState(defaultState);

  const HandleCheckBox = (id) => {
    if (isOpenBonus?.agent_bonus?.includes(id)) {
      setisOpenBonus({
        ...isOpenBonus,
        agent_bonus: isOpenBonus.agent_bonus?.filter((it) => it !== id),
      });
      // HandleDealerSelection({
      //   ...isOpenBonus,
      //   agent_bonus: isOpenBonus.agent_bonus?.filter((it) => it !== id),
      // });
    } else {
      setisOpenBonus({
        ...isOpenBonus,
        agent_bonus: isOpenBonus.agent_bonus?.concat(id),
      });
      // HandleDealerSelection({
      //   ...isOpenBonus,
      //   agent_bonus: isOpenBonus.agent_bonus?.concat(id),
      // });
    }
  };
  console.log("isOpenBonus", isOpenBonus, selectedDealerBonus);

  const toggleAllSelect = () => {
    setIsAllSelected((prevIsAllSelected) => !prevIsAllSelected);
    setSelectedAccordian(dealerBonusProducts?.map((it) => it.id));
    setMultiSelect(
      isAllSelected ? [] : dealerBonusProducts?.map((it) => it.id)
    );
  };

  const handleSwitch = (newState) => {
    setIsHighTemp(newState);
    setApplyFilters({
      ...applyFilters,
      toggleSwitch: newState ? "ht" : "lt",
    });
  };

  const handleselBonus = () => {
    setisOpenBonus(defaultState);
  };
  useEffect(() => {
    if (
      selectedDealerBonus
        ?.filter((it) => it?.product === isOpenBonus?.product)
        ?.map((item) => item?.agent_bonus)
        .flat()?.length > 0
    ) {
      setisOpenBonus({
        ...isOpenBonus, agent_bonus: selectedDealerBonus
          ?.filter(
            (it) => it?.product === isOpenBonus?.product
          )?.map((item) => item?.agent_bonus).flat()
      });
    }
  }, [selectedDealerBonus, isOpenBonus?.open]);

  return (
    <div className="">
      <section className="switch-box-section">
        <h1 className="text-sm font-[500] pb-2">Loan Product</h1>
        <div className="relative">
          {Object.keys(settingsData)?.length > 0 && (
            <div className="max-w-[1150px]">
              <SwitchBox
                title="Vehicle"
                tabs={settingsData?.vehicles}
                settingsHandle={settingsHandle}
                value={applyFilters?.vehicle}
              />
              <SwitchBox
                title="Type"
                tabs={settingsData?.categories}
                settingsHandle={settingsHandle}
                value={applyFilters?.category}
              />
              <SwitchBox
                title="Category"
                tabs={
                  settingsData.categories[
                    settingsIndex.cat == 0
                      ? settingsIndex.cat + 1
                      : settingsIndex.cat
                  ].types
                }
                settingsHandle={settingsHandle}
                value={applyFilters?.loanType}
                disabled={settingsIndex.cat == 0}
              />
              <SwitchBox
                title="Motor"
                tabs={settingsData?.productMotorTypes}
                settingsHandle={settingsHandle}
                value={applyFilters?.motorType}
              />
              <br />
              <SwitchBox
                title="Usage"
                tabs={settingsData?.productUsages}
                settingsHandle={settingsHandle}
                value={applyFilters?.usage}
              />
              <SwitchBox
                title="Scheme"
                tabs={
                  settingsData.categories[
                    settingsIndex.cat == 0
                      ? settingsIndex.cat + 1
                      : settingsIndex.cat
                  ].types[settingsIndex.typ].schemes.map((scheme) => ({
                    ...scheme,
                    disabled:
                      settingsData.vehicles[settingsIndex.veh]?.name === 'Commercial' &&
                      scheme.name === 'Balloon',
                  }))
                }
                settingsHandle={settingsHandle}
                value={applyFilters?.scheme}
                disabled={settingsIndex.cat == 0}
              />
              <SwitchBox
                title="Bank Provider"
                tabs={settingsData?.loanProviderTypes}
                settingsHandle={settingsHandle}
                value={applyFilters?.loanProvider}
              />
              {/* <SwitchBox
                title="Collect First Installment?"
                value={applyFilters?.collect_first_installment || ""}
                tabs={(settingsData.collect_first_installment_options || []).map((it) => {
                  return {
                    ...it,
                    id: it?.value !== undefined ? it?.value : "",
                  };
                })}
                settingsHandle={settingsHandle}
              />               */}
            </div>
          )}
          <SwitchButton
            initialState={isHighTemp}
            onSwitch={handleSwitch}
            leftLabel="LT"
            rightLabel="HT"
            tooltipText={LtHtContent}
            showTooltip={true}
            classNames="absolute right-0 bottom-0"
            right={applyFilters?.toggleSwitch === "ht" ? true : false}
          />
        </div>
      </section>
      <div className="p-[30px]">
        <section className="common-select-block">
          <div className="select-all-agent">
            <Checkbox
              id="select_all"
              onChange={toggleAllSelect}
              checked={isAllSelected}
            >
              Select All
            </Checkbox>
          </div>
          {multiSelect?.length > 1 && (
            <div className="select-all-product-bonus-update">
              <div className="input-group bonus-select">
                <label>Dealer Bonus</label>
                <button
                  type="button"
                  className="select_bonus_btn"
                  onClick={() =>
                    setisOpenBonus({
                      ...isOpenBonus,
                      open: true,
                      isAllSelect: true,
                    })
                  }
                >
                  Select an dealer bonus...
                  <span className="select-arrow-right">
                    <Arrow />
                  </span>
                </button>
              </div>
            </div>
          )}
        </section>
        {dealerBonusProducts?.length > 0 &&
          dealerBonusProducts.map((data, index) => (
            <AccordionBlock
              data={data}
              selectAllDealer={isAllSelected}
              setisOpenBonus={setisOpenBonus}
              index={index}
              selectedAccordian={selectedAccordian}
              setSelectedAccordian={setSelectedAccordian}
              isOpenBonus={isOpenBonus}
              selectedDealerBonus={selectedDealerBonus}
              dealerBonusList={dealerBonusList}
              setMultiSelect={setMultiSelect}
              multiSelect={multiSelect}
            />
          ))}
      </div>
      {selectedDealerBonus?.length > 0 && (
        <div className="dealer-save-cancel-btn">
          <Button
            className="can_btn"
            onClick={() => {
              setSelectedDealerBonus([]);
            }}
          >
            Cancel
          </Button>
          {pagePermissions?.update_permission == 1 && (
            <Popconfirm
              title="Save Dealer Bonus Changes"
              description="Are you sure to save the changes ?"
              onConfirm={() => {
                UpdateBonus();
              }}
              onCancel={() => setSelectedDealerBonus([])}
              okText="Save"
              cancelText="Cancel"
            >
              <Button
                type="button"
                className="sav_btn bonus_btn"
                disabled={selectedDealerBonus?.length < 1}
              >
                Save Changes
              </Button>
            </Popconfirm>
          )}
        </div>
      )}

      <CommonPopup
        size="xlg"
        isOpen={isOpenBonus.open}
        onClose={handleselBonus}
        title={`Select Bonus (${dealerBonusList ? dealerBonusList.length : 0})`}
      >
        <div className="relative">
          <div>
            <div>
              {dealerBonusList.length > 0 ? (
                dealerBonusList.map((item, idx) => {
                  return (
                    <div>
                      <label
                        htmlFor={`selBns${idx}`}
                        className={`flex items-center gap-[10px] mb-[15px] cursor-pointer "diab_lbl"
      }`}
                        key={idx}
                      >
                        {console.log("CHECKED VALUES", isOpenBonus)}
                        <Checkbox
                          id={`selBns${idx}`}
                          onClick={() => {
                            HandleCheckBox(item?.id);

                            //setIsAllSelected(false);
                            //setisOpenBonus(defaultState);
                          }}
                          checked={isOpenBonus?.agent_bonus
                            ?.includes(item?.id)}
                        />
                        <BonusCard bonus={item} pagePermissions={pagePermissions} />
                      </label>

                    </div>
                  );
                })
              ) : (
                <div className="text-center font-[700] text-[20px] mt-[30px]">
                  No Bonuses
                </div>
              )}
              <div className="mt-[25px] pl-[26px]">
                <Button type="button" className="can_btn" style={{ marginRight: '5px' }} onClick={() => {
                  setisOpenBonus(defaultState);

                }}>Cancel</Button>
                {pagePermissions?.update_permission == 1 && (
                  <Button type="button" className="sav_btn" onClick={() => {
                    HandleDealerSelection(isOpenBonus);
                    setisOpenBonus(defaultState);
                  }}>Save Changes</Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </CommonPopup>
    </div>
  );
};

export default ManageBonus;
